/**
 * True when the page is running on a developer machine (localhost, loopback,
 * *.local or a private LAN address). Analytics loaders (GTM -> GA, Clarity,
 * Meta Pixel) skip these hosts so local sessions and dev-time errors don't
 * end up in the production analytics and Clarity projects.
 *
 * Set NEXT_PUBLIC_ANALYTICS_ON_LOCALHOST=true to load the tags locally anyway
 * (for example to debug tags with GTM Preview).
 */
export function isLocalDevHost(): boolean {
  if (typeof window === "undefined") return false;
  if (process.env.NEXT_PUBLIC_ANALYTICS_ON_LOCALHOST === "true") return false;

  const host = window.location.hostname;
  return (
    host === "localhost" ||
    host.endsWith(".localhost") ||
    host.endsWith(".local") ||
    host === "0.0.0.0" ||
    host === "[::1]" ||
    host === "::1" ||
    /^127\./.test(host) ||
    /^10\./.test(host) ||
    /^192\.168\./.test(host) ||
    /^172\.(1[6-9]|2\d|3[01])\./.test(host)
  );
}
